import React, { PropTypes } from 'react';
//import './styles.scss';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {};
  }

  render () {
    return (
      <div className="contact-box text-center">
       <div className="SetterBase-row">
          <div className="SetterBase-center-col SetterBase-c-6 text-center">
            <h2 className="title">Contact Us</h2>
            <div className="SetterBase-spacer-tall"></div>
            <div className="AuthView-group-cage">
              <form className="setter-form">
                <div className="AuthView-form-cage">
                  <div className="AuthView-group">
                    <div className="AuthInput">
                      <input className="AuthInput-input" required/>
                      <span className="AuthInput-highlight"></span>
                      <span className="AuthInput-bar"></span>
                      <label className="AuthInput-label">Full name</label>
                    </div>
                  </div>
                  <div className="AuthView-group">
                    <div className="AuthInput">
                      <input className="AuthInput-input" required/>
                      <span className="AuthInput-highlight"></span>
                      <span className="AuthInput-bar"></span>
                      <label className="AuthInput-label">Email</label>
                    </div>
                  </div>
                  <div className="AuthView-group">
                    <div className="AuthInput">
                      <input className="AuthInput-input" required/>
                      <span className="AuthInput-highlight"></span>
                      <span className="AuthInput-bar"></span>
                      <label className="AuthInput-label">Subject</label>
                    </div>
                  </div>
                  <div className="AuthView-group">
                    <div className="AuthInput">
                      <textarea className="AuthInput-input" rows="4" required></textarea>
                      <span className="AuthInput-highlight"></span>
                      <span className="AuthInput-bar"></span>
                      <label className="AuthInput-label">Your Message</label>
                    </div>
                  </div>
                </div>
                <div className="AuthView-btn-cage text-center">
                  <button className="AuthView-form-btn AuthView-btn text-uppercase">SEND</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

ContactForm.propTypes = {

};

ContactForm.defaultProps = {

};

export default ContactForm;



/** WEBPACK FOOTER **
 ** ./_contact_form.js
 **/